export { ReactComponent as LsUndo } from './undo.svg';
export { ReactComponent as LsRedo } from './redo.svg';
export { ReactComponent as LsRemove } from './remove.svg';
export { ReactComponent as LsTrash } from './trash.svg';
export { ReactComponent as LsPlus } from './plus.svg';
export { ReactComponent as LsSparks } from './sparks.svg';
export { ReactComponent as LsComment } from './comment-check.svg';
export { ReactComponent as LsCommentRed } from './comment-red.svg';
export { ReactComponent as LsCommentResolved } from './comment-resolved.svg';
export { ReactComponent as LsCommentUnresolved } from './comment-unresolved.svg';
export { ReactComponent as LsParentLink } from './parent-link.svg';
export { ReactComponent as LsAnnotation } from './annotation.svg';
export { ReactComponent as LsGrid } from './grid.svg';
export { ReactComponent as LsSettings } from './settings.svg';
export { ReactComponent as LsSettingsAlt } from './settings-alt.svg';
export { ReactComponent as LsStar } from './star.svg';
export { ReactComponent as LsStarOutline } from './star-outline.svg';
export { ReactComponent as IconBan } from './ban.svg';
export { ReactComponent as LsVisible } from './visible.svg';
export { ReactComponent as LsInvisible } from './invisible.svg';
export { ReactComponent as LsChevron } from './chevron.svg';
export { ReactComponent as LsExpand } from './expand.svg';
export { ReactComponent as LsExpandSmall } from './expand-small.svg';
export { ReactComponent as LsExpandAlt } from './expand-alt.svg';
export { ReactComponent as LsCollapse } from './collapse.svg';
export { ReactComponent as LsCollapseSmall } from './collapse-small.svg';
export { ReactComponent as LsDate } from './date.svg';
export { ReactComponent as LsClose } from './close.svg';
export { ReactComponent as IconPlusCircle } from './plus-circle.svg';
export { ReactComponent as IconSlow } from './slow.svg';
export { ReactComponent as IconFast } from './fast.svg';
export { ReactComponent as IconDuplicate } from './duplicate.svg';
export { ReactComponent as IconEllipsis } from './ellipsis.svg';
export { ReactComponent as IconWarning } from './warning.svg';
export { ReactComponent as IconPlay } from './play.svg';
export { ReactComponent as IconPause } from './pause.svg';
export { ReactComponent as IconHelp } from './help.svg';

export { ReactComponent as IconCheck } from './check.svg';
export { ReactComponent as IconCheckBold } from './check-bold.svg';
export { ReactComponent as IconCross } from './cross.svg';
export { ReactComponent as IconCrossBold } from './cross-bold.svg';

export { ReactComponent as IconPlayerPause } from './player/pause.svg';
export { ReactComponent as IconPlayerPlay } from './player/play.svg';
export { ReactComponent as IconPlayerStep } from './player/step.svg';

export { ReactComponent as IconVolumeMute } from './volume-mute.svg';
export { ReactComponent as IconVolumeHalf } from './volume-half.svg';
export { ReactComponent as IconVolumeFull } from './volume-full.svg';

// Tools
export { ReactComponent as IconBrushTool } from './tools/brush-tool.svg';
export { ReactComponent as IconBrushToolSmart } from './tools/brush-tool-smart.svg';
export { ReactComponent as IconCircleTool } from './tools/circle-tool.svg';
export { ReactComponent as IconCircleToolSmart } from './tools/circle-tool-smart.svg';
export { ReactComponent as IconKeypointsTool } from './tools/keypoints-tool.svg';
export { ReactComponent as IconKeypointsToolSmart } from './tools/keypoints-tool-smart.svg';
export { ReactComponent as IconPolygonTool } from './tools/polygon-tool.svg';
export { ReactComponent as IconPolygonToolSmart } from './tools/polygon-tool-smart.svg';
export { ReactComponent as IconRectangleTool } from './tools/rectangle-tool.svg';
export { ReactComponent as IconRectangleToolSmart } from './tools/rectangle-tool-smart.svg';
export { ReactComponent as IconRectangle3PointTool } from './tools/rectangle-3point-tool.svg';
export { ReactComponent as IconRectangle3PointToolSmart } from './tools/rectangle-3point-tool-smart.svg';
export { ReactComponent as IconMagicWandTool } from './tools/magic-wand-tool.svg';
export { ReactComponent as IconEraserTool } from './tools/eraser-tool.svg';
export { ReactComponent as IconHandTool } from './tools/hand-tool.svg';
export { ReactComponent as IconBrightnessTool } from './tools/brightness-tool.svg';
export { ReactComponent as IconContrastTool } from './tools/contrast-tool.svg';

export { ReactComponent as IconZoomIn } from './tools/magnify-tool.svg';
export { ReactComponent as IconZoomOut } from './tools/minify-tool.svg';
export { ReactComponent as IconExpand } from './tools/expand-tool.svg';
export { ReactComponent as IconMoveTool } from './tools/move-tool.svg';
export { ReactComponent as IconRotateLeftTool } from './tools/rotate-left-tool.svg';
export { ReactComponent as IconRotateRightTool } from './tools/rotate-right-tool.svg';
export { ReactComponent as IconInfoOutline } from './info-outline.svg';
export { ReactComponent as IconInfo } from './info.svg';
export { ReactComponent as IconCopy } from './copy.svg';
export { ReactComponent as IconText } from './text.svg';
export { ReactComponent as IconViewAll } from './view-all.svg';
export { ReactComponent as IconLink } from './link.svg';
export { ReactComponent as IconPlusAlt } from './plus-alt.svg';
export { ReactComponent as IconTrash } from './trash.svg';
export { ReactComponent as IconTrashRect } from './trash-rect.svg';
export { ReactComponent as IconMenu } from './menu.svg';
export { ReactComponent as IconMinus } from './minus.svg';
export { ReactComponent as IconHamburger } from './hamburger.svg';
export { ReactComponent as IconDetails } from './details.svg';
export { ReactComponent as IconLockLocked } from './locked.svg';
export { ReactComponent as IconLockUnlocked } from './unlocked.svg';
export { ReactComponent as IconCursor } from './cursor.svg';
export { ReactComponent as IconList } from './list.svg';
export { ReactComponent as IconSpeed } from './speed.svg';
export { ReactComponent as IconTagAlt } from './tag-alt.svg';
export { ReactComponent as IconSortUp } from './sort-up.svg';
export { ReactComponent as IconSortUpNew } from './sort-up-new.svg';
export { ReactComponent as IconSortDown } from './sort-down.svg';
export { ReactComponent as IconSortDownNew } from './sort-down-new.svg';
export { ReactComponent as IconFilter } from './filter.svg';
export { ReactComponent as IconDelete } from './delete.svg';

export { ReactComponent as IconArrowLeft } from './arrow-left.svg';
export { ReactComponent as IconArrowLeftSmall } from './arrow-left-small.svg';
export { ReactComponent as IconArrowRight } from './arrow-right.svg';
export { ReactComponent as IconArrowRightSmall } from './arrow-right-small.svg';

// Relations
export { ReactComponent as IconRelationRight } from './relations/right.svg';
export { ReactComponent as IconRelationLeft } from './relations/left.svg';
export { ReactComponent as IconRelationBi } from './relations/bi.svg';

// Properties
export { ReactComponent as IconPropertyAngle } from './properties/angle.svg';

export * from './annotation';
export * from './outliner';
